"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paymentMethod = exports.fullName = exports.expiryCvv = exports.expiry = exports.cvv = exports.copyButtonIcon = exports.copyButton = exports.cardNumber = exports.card = void 0;

var _react = require("@emotion/react");

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  height: 207px;\n  width: 327px;\n  font-weight: ", ";\n  color: ", ";\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  bottom: 15px;\n  left: 17px;\n  color: ", ";\n  font-size: 73.3333333333%;\n  font-weight: ", ";\n  line-height: 1.37em;\n  text-transform: ", ";\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 17px;\n  top: 73%;\n  font-size: ", ";\n  letter-spacing: 2px;\n  transform: translateY(-50%);\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-left: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 16px;\n  width: 16px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  right: 11px;\n  border-radius: 50%;\n  height: 32px;\n  min-width: unset;\n  width: 32px;\n  transform: translateY(-50%);\n  background-color: ", ";\n  :hover {\n    background-color: ", ";\n  }\n  span {\n    width: auto;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 17px;\n  top: 50%;\n  font-size: ", ";\n  letter-spacing: 2px;\n  word-spacing: 12px;\n  transform: translateY(-50%);\n  z-index: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var card = (0, _react.css)(_templateObject());
exports.card = card;

var cardNumber = function cardNumber(_ref) {
  var fontSizes = _ref.fontSizes;
  return (0, _react.css)(_templateObject2(), fontSizes.heading3);
};

exports.cardNumber = cardNumber;

var copyButton = function copyButton(_ref2) {
  var name = _ref2.name,
      colors = _ref2.colors;
  return (0, _react.css)(_templateObject3(), colors.primary.medium, name === 'legacy' ? colors.primary : colors.primary.dark);
};

exports.copyButton = copyButton;
var copyButtonIcon = (0, _react.css)(_templateObject4());
exports.copyButtonIcon = copyButtonIcon;

var cvv = function cvv(theme) {
  return (0, _react.css)(_templateObject5(), theme.name === 'legacy' ? '57px' : '62px');
};

exports.cvv = cvv;
var expiry = (0, _react.css)(_templateObject6());
exports.expiry = expiry;

var expiryCvv = function expiryCvv(_ref3) {
  var fontSizes = _ref3.fontSizes;
  return (0, _react.css)(_templateObject7(), fontSizes.body4);
};

exports.expiryCvv = expiryCvv;

var fullName = function fullName(_ref4) {
  var name = _ref4.name,
      colors = _ref4.colors,
      fontWeights = _ref4.fontWeights;
  return (0, _react.css)(_templateObject8(), colors.neutral[400], fontWeights.normal, name === 'legacy' ? 'uppercase' : 'none');
};

exports.fullName = fullName;

var paymentMethod = function paymentMethod(_ref5) {
  var name = _ref5.name,
      colors = _ref5.colors,
      fontWeights = _ref5.fontWeights;
  return (0, _react.css)(_templateObject9(), fontWeights.medium, name === 'legacy' ? colors.primary : colors.white);
};

exports.paymentMethod = paymentMethod;